// extracted by mini-css-extract-plugin
module.exports = {"imageBase":"Image_imageBase__TA3yn"};